var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-img-top"},[_c('gmap-map',{staticStyle:{"width":"100%","height":"300px"},attrs:{"center":_vm.center,"zoom":17,"options":{
               mapTypeControl: false,
               disableDefaultUI: true,
             }}},[_c('gmap-marker',{attrs:{"position":_vm.position},on:{"click":function($event){return _vm.markerClick(_vm.m)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }